export default function SectionTag({ index, label, light = false }) {
  return (
    <p className={`eyebrow flex items-center gap-3 ${light ? '!text-[rgba(250,247,242,0.6)]' : ''}`} data-testid={`section-tag-${index}`}>
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${light ? 'bg-[#FCD116]' : 'bg-[#FF6B35]'}`} />
      <span>
        ( {index} ) — {label}
      </span>
    </p>
  )
}
